import React from 'react';

export const getLocationDisplayName = (location) => {
  if (!location) return '';
  const i18nName = location.meta_data?.i18n?.name?.['en_US']
    || location.meta_data?.i18n?.name?.['zh_HK']
    || location.meta_data?.i18n?.name?.['zh_CN']
    || location.primary_name;
  if (location.external_location_code) {
    return `${i18nName} (${location.external_location_code})`;
  }
  return i18nName;
};

const LocationSelect = ({
  locations = [],
  value,
  onChange,
  name = 'location_id',
  includeNoneOption = true,
  noneLabel = '— None (clinic-wide) —',
  placeholder,
  disabled = false,
  className = 'w-full p-2 border rounded',
}) => {
  return (
    <select
      name={name}
      value={value === null || value === undefined ? '' : String(value)}
      onChange={onChange}
      disabled={disabled}
      className={className}
    >
      {includeNoneOption && <option value="">{noneLabel}</option>}
      {!includeNoneOption && placeholder && (
        <option value="" disabled>{placeholder}</option>
      )}
      {locations.map((location) => (
        <option key={location.id} value={String(location.id)}>
          {getLocationDisplayName(location)}
        </option>
      ))}
    </select>
  );
};

export default LocationSelect;
